import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface LaunchWaitlistFormProps {
  email: string;
  setEmail: (email: string) => void;
  submitted: boolean;
  loading: boolean;
  onSubmit: () => void;
  submittedMessage?: string;
  buttonLabel?: string;
  showDesignPartnerLink?: boolean;
}

const LaunchWaitlistForm = ({
  email,
  setEmail,
  submitted,
  loading,
  onSubmit,
  submittedMessage = "You're in \u2014 we'll be in touch within 48 hours.",
  buttonLabel = 'Book a Demo',
  showDesignPartnerLink = true,
}: LaunchWaitlistFormProps) => {
  if (submitted) {
    return (
      <div className="flex items-center justify-center gap-2 text-primary font-medium py-3">
        <Check size={20} /> {submittedMessage}
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Input
          type="email"
          placeholder="you@venue.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="h-12 text-base flex-1"
          onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
        />
        <Button
          size="lg"
          className="h-12 px-8 text-base whitespace-nowrap"
          disabled={loading}
          onClick={onSubmit}
        >
          {loading ? 'Sending\u2026' : buttonLabel}
          {!loading && <ArrowRight size={16} className="ml-2" />}
        </Button>
      </div>
      {showDesignPartnerLink && (
        <p className="text-xs text-muted-foreground mt-3 text-center">
          Want to go deeper?{' '}
          <Link to="/design-partners" className="text-primary underline hover:text-primary/80">
            Apply to be a Founding Design Partner &rarr;
          </Link>
        </p>
      )}
    </>
  );
};

export default LaunchWaitlistForm;
